// extracted by mini-css-extract-plugin
export default {"wrapper":"attachments_wrapper__eXaPv","btnWrapper":"attachments_btnWrapper__zM47I"};